<template>
<v-container fluid class="pa-0">
    <PageHeader :contextStyle="contextStyle">
      <PageHeader :contextStyle="contextStyle">
            <template #right v-if="( $route.params.zon_id == undefined )">
                <router-link :to="{ name: 'zones-edit', params: { zon_id: 0 } }">
                    <v-btn small rounded color="primary">Créer une fiche</v-btn>
                </router-link>
            </template>
        </PageHeader>
    </PageHeader>

    <ItemForm v-if="( $route.params.zon_id !== undefined && parseInt( $route.params.zon_id ) >= 0 )"/>
    <v-card v-else :class="($root.$mobileView) ? 'mt-0 mb-2 ml-0 mr-0 rounded-lg' : 'ma-4 rounded-lg'">
        <ItemsList />
    </v-card>

</v-container>
</template>

<script>
import PageHeader from '@/components/ui/PageHeader'
import ItemsList from '@/components/zones/ZonesList'
import ItemForm   from '@/components/zones/ZonesForm'
//import { filterUpdateService } from '@/rxjsServices';

export default {
    name: 'zones-page',
    props: ['contextStyle'],
    components: {
        PageHeader,
        ItemsList,
        ItemForm
    },
    data: function () {
        return {
            loading: { getXls: false, getTasks: false },         // Enregistrement en cours...
            items: [],
            enableAdd: true,
            modalEvent : false
        }
    },
    computed: { },
    created(){},
    mounted: function (){
        //this.search = cacheGetters.getSearchBarItem('tasktypes') || ''
        //this.getItems()
    },
    methods: {
        async getItems(){
            this.items = []
        }
    },
    beforeDestroy() {
        //this.subTask.unsubscribe()
    },
}
</script>